import { localize } from "@gtmhub/localization";
import { ISubTitle } from "@gtmhub/shared/components/ui/top-navigation-bar/top-nav-bar.component";

const getStateKey = (key: string) => {
  return {
    "gtmhub.employees": localize("employees"),
    "gtmhub.teams": localize("teams_cap"),
    "gtmhub.organization_chart": localize("organization"),
    "gtmhub.list": localize("all_reports"),
    "gtmhub.home": localize("dashboard"),
  }[key];
};

export const createBreadCrumb = (path: string): ISubTitle => {
  const secondDotIndex = path.indexOf(".", path.indexOf(".") + 1);
  let state = secondDotIndex === -1 ? path : path.substring(0, secondDotIndex);
  let subtitle = getStateKey(state);

  if (!subtitle) {
    state = "gtmhub.teams";
    subtitle = getStateKey("gtmhub.teams");
  }

  return { text: subtitle, action: { state: state } };
};
